export default __webpack_public_path__ + "static/9_34-1--c72600330f4771b314a7c1130ef9aa45.png";